export class CustomerFilter {

  constructor() { }

  customerId: number;
  contractorName: string;
  contractorINN: string;
  contractorKPP: string;
  contractorLevel: string;
  contractorType: string;
  contractorOKOPF: string;
  contractorCategory: string;
  

}



// WEBPACK FOOTER //
// ./src/app/modules/home/models/customer-filter.ts